<template>
  <div>
  <div 
    v-if="!json.init"
    class="spe-roll-picture" 
    :style="{
      backgroundColor: commonStyle.usePageBackgroundColor ? commonStyle.bgColor : commonStyle.backgroundColor ,
      backgroundImage: commonStyle.backgroundType == 2 ? `url(${commonStyle.backgroundImage})` : '',
    }"
    :ddt-area="`component_${floorId}`"
    ddt-expose="on"
  >
    <div class="roll-wrap" :style="{margin: commonStyle.margin ? `0 ${commonStyle.margin}px` : '0'}">
      <div class="roll-container" :id="`j-rollCon-${floorIndex}`">
        <ul class="list" :ddt-area="`单行滑动组件-${floorIndex}`">
          <template v-if="pitContent.length > 4">
            <!-- 由于数据会有单数的情况，所以数据统一多写一遍来支持无限轮播 -->
            <template v-for="v in 6">
              <li ddt-pit="坑位" :ddt-src="index + 1" v-for="(el, index) in pitContent" :key="`_${index}`">
                <a 
                  href="javascript:void(0);"
                  :style="{
                    background: info.bgColor ? info.bgColor : '#FF8C5C',
                    border: `1px solid ${info.bgColor ? info.bgColor : '#FF8C5C'}`
                  }"
                  @click.stop.prevent="$sys.dict.href(el.jumpUrl)"
                >
                  <div class="image-wrap"><img class="image" :class="{type1: styleType == 1}" :src="el.imageUrl"></div>
                  <div class="price" v-if="styleType == 3"><span class="rmb">￥</span><span class="integer">{{getPriceObj(el.title).integer}}</span><span class="decimal">{{getPriceObj(el.title).decimal}}</span><span v-if="getPriceObj(el.title).qi" class="qi">{{getPriceObj(el.title).qi}}</span></div>
                  <div class="title-wrap" v-if="styleType == 2"><div class="title">{{ el.title }}</div></div>
                </a>
              </li>
            </template>
          </template>
          <li v-else ddt-pit="坑位" :ddt-src="index + 1" v-for="(el, index) in pitContent" :key="`_${index}`">
            <a 
              href="javascript:void(0);"
              :style="{
                background: info.bgColor ? info.bgColor : '#FF8C5C',
                border: `1px solid ${info.bgColor ? info.bgColor : '#FF8C5C'}`
              }"
              @click.stop.prevent="$sys.dict.href(el.jumpUrl)"
            >
              <div class="image-wrap"><img class="image" :class="{type1: styleType == 1}" :src="el.imageUrl"></div>
              <div class="price" v-if="styleType == 3"><span class="rmb">￥</span><span class="integer">{{getPriceObj(el.title).integer}}</span><span class="decimal">{{getPriceObj(el.title).decimal}}</span><span v-if="getPriceObj(el.title).qi" class="qi">{{getPriceObj(el.title).qi}}</span></div>
              <div class="title-wrap" v-if="styleType == 2"><div class="title">{{ el.title }}</div></div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>
<script>
import { priceIntegerDecimal } from  '../assets/js/format'
export default {
	name: "SpeRollPicture",
	props: {
		json: {
			type: Object,
			default: () => ({ commonStyle: {}, pitContent: [], styleType: 1 }),
		},
    floorIndex: {
      type: [String, Number] ,
      default: '',
    }
	},
	data() {
		return {
      isAutoPlay: true, // 是否轮播
      pagination: false, // 是否显示指示器
      showNum: 4, // 一屏显示的数据个数
      scale: 1.16, // 放大倍数
      pitContent: [],
      styleType: 1,
      commonStyle: {},
      info: {}
    };
	},
  inject: ['pt'],
	computed: {
    jdata() {
      return this.json.data || {commonStyle: {}, pitContent: [], styleType: 1, info: {}};
    },
  },
  watch: {
    json: {
      handler(newVal) {
        let { data, floorId } = newVal
        if(!data) {
          return
        }
        this.floorId = floorId
        let { pitContent, styleType, commonStyle, info } = data
        if(!styleType || !pitContent || !commonStyle) {
          return
        }
        this.pitContent = pitContent
        this.styleType = styleType
        this.commonStyle = commonStyle
        this.info = info
        // padding: commonStyle.margin ? `0 ${commonStyle.margin}px` : '0'
        this.$nextTick(() => {
					this.swiper();
				});
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getPriceObj(price) {
			return priceIntegerDecimal(price)
		},
    swiper() {
      let obj = document.getElementById(`j-rollCon-${this.floorIndex}`); //获取包裹元素
      let pagination = this.pagination || false;  //是否有高亮圆点，默认无，如需要自行设置元素
      let isAutoPlay = this.isAutoPlay || false;   //是否自动播放，默认不自动播放
      let duration = this.info.interval * 1000 || 5000;  //自动播放时间间隔
      let showNum = this.showNum; // 模块显示数量
      let scale = this.scale || 1 // 放大倍数
      let $list = obj.getElementsByTagName('ul')[0]
      let data = $list.getElementsByTagName('li')
      let loopTimes = 3 // 原始数据循环次数
      let dataLen = data.length / loopTimes // 原始数据长度
      let liLen = dataLen / 2 // 真实数据长度

      // let fontSize = window.getComputedStyle(window.document.documentElement)['font-size'] || '14px' // 根节点字号
      // if (liLen > showNum) {
      //   let html = ''
      //   for (let i = 0; i < loopTimes - 1; i++) {
      //     html += $list.innerHTML
      //   }
      //   $list.innerHTML = html // 往里面追加两遍数据，用于无缝切换
      //   data = $list.getElementsByTagName('li')
      // }
      let dWdith = Math.floor(parseFloat(window.getComputedStyle(obj).width) / showNum);
      for (let i = 0, j = data.length; i < j; i++) {
        data[i].style.width = dWdith + 'px'
      }
      // 根据放大倍数计算上下padding值
      if (scale > 1) {
        obj.style.padding = Math.ceil(dWdith * (scale - 1) / 2) + 'px 0'
      }
      $list.style.width = dWdith * data.length + 'px'
      $list.style.marginLeft = ((parseFloat(window.getComputedStyle(obj).width) - dWdith * showNum) / 2) + 'px' // 防止页面两端会露出来

      let intervalTimer = null // 轮播定时器
      // offsetLeft无法获取通过2D变换产生的偏移,可以通过translateX变量来记录偏移量。
      let translateX = 0;
      //需要一个索引值
      let now = dataLen
      setTimeout(function () {setSwiper(now)}, 300)
      // 计算是否可以轮播(>4)
      if (liLen <= showNum) {
        return
      }
      
      // 给swiperWrapp监听 transitionend事件
      obj.addEventListener('transitionend', function () {
        if (now + showNum >= dataLen * (loopTimes - 1)) {
          // 如果切换到了最后一张
          // 设置index变为上一组的最后一张
          now -= dataLen
          //快速切换到index的位置
          $list.style.transition = 'none'
          setSwiper(now);
        } else if (now + showNum < dataLen) {
          // 设置index变为上一组的第一张
          now += dataLen
          //快速切换到index的位置
          $list.style.transition = 'none'
          setSwiper(now)
        }
      }, false);
      if (isAutoPlay) {
        intervalTimer = setInterval(runSwiper, duration);
      }
      function runSwiper() {
        // 索引自增
        now++;
        // 添加过渡效果
        $list.style.transition = '0.5s transform'
        // 执行切换
        setSwiper(now);
      }
      function setSwiper(now) {
        if (data.length <= 4) {
          for (let i = 0, j = data.length; i < j; i++) {
            if (i % 2 === 0) {
              data[i].style.transform = 'scale(' + scale + ')'
            } else {
              data[i].style.transform = 'scale(1)'
            }
          }
        } else {
          for (let i = 0, j = data.length; i < j; i++) {
            if (now % 2 === 0) {
              if (i % 2 == 0) {
                data[i].style.transform = 'scale(' + scale + ')'
              } else {
                data[i].style.transform = 'scale(1)'
              }
            } else {
              if (i % 2 === 1) {
                data[i].style.transform = 'scale(' + scale + ')'
              } else {
                data[i].style.transform =  'scale(1)'
              }
            }
          }
        }
        if (liLen > showNum) {
          let translateX = -now * dWdith;
          $list.style.transform = 'translateX(' + translateX + 'px)'
        }
      }
    }
  }
}
</script>
<style>
.spe-roll-picture {
  background-repeat: repeat-y;
  background-position: left top;
  background-size: 100%;
}
.roll-wrap {
  overflow: hidden;
  padding: 0.28rem 0.06rem 0.28rem 0.16rem;
  box-sizing: border-box;
}
.roll-container {
  overflow: hidden;
  position: relative;
  font-size: 0;
}
.roll-container .list {
  width: 100%;
}
.roll-container li {
  width: 100%;
	padding: 0 0.13rem;
	float: left;
	box-sizing: border-box;
	/* transition: all 0.3s; */
}
.roll-container li a {
  display: block;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  background-size: auto;
  border: 1px solid #FF8C5C;
  border-radius: 0.32rem;
  text-align: center;
  color: #FFF;
  background: #FF8C5C;
}
.roll-container .image-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0.04rem;
	/*min-height: 1.2rem;*/
	background: #FFF;
	border-radius: 0.28rem;
	overflow: hidden;
}
.roll-container .image {
	height: 1.16rem;
	width: 1.16rem;
	object-fit: contain;
	object-position: 50% 50%;
}
.roll-container .image.type1 {
	height: 1.48rem;
	width: 1.48rem;
}
.roll-container .title-wrap {
  height: 0.70rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.roll-container .title-wrap .title{
  font-size: 0.24rem;
  line-height: .28rem;
  padding: 0 0.04rem;
  display: -webkit-box;
  overflow: hidden;
  box-sizing: border-box;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.roll-container .price {
  height: 0.48rem;
  line-height: 0.48rem;
  font-size: 0.24rem;
}
.roll-container .price .integer {
  font-weight: bold;
}
.roll-container .price .rmb, .roll-container .price .decimal , .roll-container .price .qi {
  font-size: 0.2rem;
  line-height: 0.28rem;
  font-weight: bold;
}
</style>
